import * as React from 'react';
import PolicyPage from '../policy/PolicyPage';
import { usePolicyText, getPolicyTextUrl, getPolicyPdfUrl } from '../policy/usePolicyText';

/** Azure Blob or other URL for privacy text. Fallback: local /policies/privacy.txt */
const PRIVACY_TEXT_URL = getPolicyTextUrl(
  process.env.REACT_APP_PRIVACY_TEXT_URL,
  '/policies/privacy.txt'
);

/** Azure Blob or other URL for privacy PDF. Fallback: local /privacy.pdf */
const PRIVACY_PDF_URL = getPolicyPdfUrl(
  process.env.REACT_APP_PRIVACY_PDF_URL,
  '/policies/privacy.pdf'
);

export default function PrivacyPage() {
  const { content, loading, error } = usePolicyText(PRIVACY_TEXT_URL);

  return (
    <PolicyPage
      title="Privacy Policy"
      content={content}
      loading={loading}
      error={error}
      pdfUrl={PRIVACY_PDF_URL}
    />
  );
}
